import React from "react";
import { Link } from "react-router-dom";
import ctaPlayer from "../../assets/images/cta-player.jpg";
import { Container } from "react-bootstrap";

const HomeCTA = () => (
    <Container>
        <section className="cta shell card">
            <div className="cta-copy">
                <h2>READY TO JOIN THE <span>FIGHT?</span></h2>
                <p>Join thousands of fans turning NBA history into real wins.</p>
                <Link to="/signup" className="btn btn-primary btn-large">JOIN NOW</Link>
                <small>Plans start at $9.99 / month</small>
            </div>
            <img src={ctaPlayer} alt="Basketball player celebrating" />
        </section>
    </Container>
);

export default HomeCTA;
